import { render } from "./Retailer.vue?vue&type=template&id=5cc700c0&scoped=true"
import script from "../js/retailer.js?vue&type=script&lang=js"
export * from "../js/retailer.js?vue&type=script&lang=js"

import "./Retailer.vue?vue&type=style&index=0&id=5cc700c0&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc700c0"]])

export default __exports__